import { Routes } from "@angular/router";
import { QueueAlertsListComponent } from "./queue-alerts-list/queue-alerts-list.component";
import { actionsGuard } from "../shared/guards/actions.guard";

export const queueAlertsRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: QueueAlertsListComponent, canActivate: [actionsGuard] },
  // { path: 'create', component: UserCreatedComponent, canActivate: [actionsGuard] },
];
